/**
 * A queued collection of appView models.
 * @class
 */
import Base from './appViews';

class AppViewsQueue extends Base {
	/** @override */
	constructor(models, opts = {}) {
		super(models, opts);

		this.isQueue = true;

		// Reference to the viewCollection we are acting as a queue for
		const queueFor = (this.queueFor = opts.queueFor);
		const view = (this.view = opts.view);

		// Backup
		this.oldQueueForSet = queueFor.set;
		// collection.add is a middle man for set - set by itself produces no options by default
		queueFor.set = (models, opts) => {
			// If we are fixing to get out of here, store the incoming views
			// so we can reshow when done
			if (view.preparingToHide || view.removing) {
				this.set(models, {remove: false});
				return;
			}
			// Let it run as usual
			return this.oldQueueForSet.call(queueFor, models, opts);
		};

		// Backup
		this.oldQueueForRemove = queueFor.remove;
		queueFor.remove = (models, opts) => {
			this.remove(models);
			// Let it run as usual
			return this.oldQueueForRemove.call(queueFor, models, opts);
		};
	}

	/** @override */
	garbageCollect() {
		this.queueFor.remove = this.oldQueueForRemove;
		this.queueFor.set = this.oldQueueForSet;

		super.garbageCollect();
	}

	/** @type {string} */
	static get __name__() {
		return 'AppViewsQueue';
	}
}

export default AppViewsQueue;
